import React from 'react'
import GenericPullConfigListing from '../GenericPullConfigListing';
import TenableScMappingForm from './TenableScMappingForm';
import TenableScCredentialsForm from './TenableScCredentialsForm';
import { columnRenderArrayData } from 'utils/tableUtils';
import { isEmpty } from 'lodash';

export default function TenableScConfigListing(props) {
     const extraColumns = [
        {
          dataIndex: "assetName",
          title: "Asset",
          render: (assetName) =>
                    isEmpty(assetName) ? "All assets" : columnRenderArrayData(assetName),
          width: 200,
        },
      ];

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={TenableScMappingForm}
            CredentialsForm={TenableScCredentialsForm}
            extraColumns={extraColumns}
        />
    )
}